import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeAll as handleChangeAllAction } from "../../../actions/handleChangeAction";
import { getMiljogebyrTilBehandling as getMiljogebyrTilBehandlingAction } from "../../../actions/miljogebyrTilBehandlingActions";
import { getMiljoleveringstyper as getMiljoleveringstyperAction } from "../../../actions/miljoleveringstyperActions";
import { getOvertredelseskoderMiljogebyr as getOvertredelseskoderMiljogebyrAction } from "../../../actions/overtredelseskoderMiljogebyrActions";
import {
  getMiljogebyrTilBehandlingQueryParameters,
  getMiljogebyrTilBehandlingTableRows,
} from "../../../selectors/miljogebyrTilBehandlingSelector";
import Utskrift from "../Utskrift";

import { miljogebyr as miljogebyrTitle } from "../../../constants/titles";

function UtskriftContainer(props) {
  const dispatch = useDispatch();
  const queryParameters = useSelector(
    getMiljogebyrTilBehandlingQueryParameters,
  );
  const miljogebyrTableRows = useSelector(getMiljogebyrTilBehandlingTableRows);
  const getMiljogebyrer = useCallback(
    (params, page, count) =>
      dispatch(getMiljogebyrTilBehandlingAction(params, page, count)),
    [dispatch],
  );
  const handleChangeAll = useCallback(
    (payload) =>
      dispatch(
        handleChangeAllAction("MILJOGEBYRER_OVERSIKT_FILTER_FORM", payload),
      ),
    [dispatch],
  );
  const getOvertredelseskoderMiljogebyr = useCallback(
    () => dispatch(getOvertredelseskoderMiljogebyrAction()),
    [dispatch],
  );
  const getMiljoleveringstyper = useCallback(
    () => dispatch(getMiljoleveringstyperAction()),
    [dispatch],
  );

  return (
    <Utskrift
      {...props}
      queryParameters={queryParameters}
      miljogebyrTableHeaders={[
        "Ilegg.nr.",
        "Ilegg.dato",
        "Klokkeslett",
        "Tjenestenr.",
        "Overt.kode",
        "Leveringstype",
        "Mottaker",
        "Gatenavn",
        "Gatenr.",
        "Ved",
        "Ved nr.",
        "GNR",
        "BNR",
        "Bilde",
      ]}
      miljogebyrTableRows={miljogebyrTableRows}
      getMiljogebyrer={getMiljogebyrer}
      handleChangeAll={handleChangeAll}
      getOvertredelseskoderMiljogebyr={getOvertredelseskoderMiljogebyr}
      getMiljoleveringstyper={getMiljoleveringstyper}
      title="Til behandling"
      documentTitle={miljogebyrTitle.tilBehandling}
    />
  );
}

export default UtskriftContainer;
